import FilePreviewComponent from '@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue';
import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import {
  ASSIGN_UPDATE_TEMPLATE,
  ASSIGN_WORKFLOW_TO_ENTITY_TYPE_TEMPLATE,
  CREATE_FORM,
  ENTITY_REGISTER,
  GET_ENTITY_TYPE_FORMS,
  get_headers,
  get_project_id,
  GET_WORKFLOW_ASSIGNED_TO_TEMPLATE,
  LIST_STATUS_TEMPLATE,
  LIST_WORFLOWS,
  UPDATE_TEMPLATE,
  UPLOAD_TEMPLATE_URL
} from "@/utils/constants/constants.js";

import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import {
  validate_file,
  validate_non_empty_string,
  validate_non_sub_zero_number,
} from "@/utils/validations/validate_inputs";
import InvoiceSteps from "@/views/probaworkflows_base/invoicing/invoice_steps/InvoiceSteps.vue";
import ComplianceRules from "@/views/probaworkflows_base/management/compliance_management/compliance_rules/ComplianceRules.vue";
import AssignedSubEntities from "@/views/probaworkflows_base/management/entity_management/assigned_sub_entities/AssignedSubEntities.vue";
import EntityTypeAttributes from "@/views/probaworkflows_base/management/entity_management/entity_type_attributes/EntityTypeAttributes.vue";
import WidgetManagement from "@/views/probaworkflows_base/management/entity_management/entity_type_widgets/WidgetManagement.vue";
import CreateForms from "@/views/probaworkflows_base/management/survey_managment/create_forms/CreateForms.vue";
import axios from "axios";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import $ from "jquery";
import { nextTick } from "vue";
import ManageApprovalRules from "../approval_rules_management/manage_approval_rules/ManageApprovalRules.vue";

export default {
  name: "ViewEntityType",
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable,
    ManageApprovalRules,
    CreateForms,
    InvoiceSteps,
    ComplianceRules,
    NavigationBackButton,
    AssignedSubEntities,
    FilePreviewComponent,
    EntityTypeAttributes,
    WidgetManagement
  },
  data: () => ({
    headers: get_headers(),
    project_id: get_project_id(),
    entity_type_id: sessionStorage.getItem("entity_type_id"),
    entity_type_name: sessionStorage.getItem('entity_type_name'),
    selected_form_id: "",
    active_tab: "Fields Required",
    tabs: [
      "Fields Required",
      "Forms",
      "Template",
      "Invoice Steps",
      "Widgets"
      // "Compliance", removed until refactored
      // "Sub-Entities",
    ],
    email: "",
    form_list: [],
    form_table_headers: [],
    assigned_templates: [],
    loading_templates: false,
    table_safe_form_list: [],
    manage_template: [],
    manage_approval_rules: [],
    manage_invoice_steps: [],
    manage_compliance: [],
    document_url: null,
    form_name: "",
    form_description: "",
    dataTable: null,
    selected_template: {},
    selected_file: "",
    upload_loading: false,
    show_upload_modal: false,
    new_template_name: "",
    upload_from_entity_page: false,
    upload_entity_type_id: null,
    preview_modal: false,
    template_document_entity_type_id: null,
    workflows: [],
    workflows_table_headers: [],
    assigned_workflow: [],
  }),
  computed: {
    filtered_data() {
      switch (this.active_tab) {
        case "Forms":
          return this.form_list;
        case "Template":
          return this.manage_template;
        case "Invoice Steps":
          return this.manage_invoice_steps;
        case "Compliance":
          return this.manage_compliance;
        default:
          return [];
      }
    },
  },
  mounted() {
    this.headers = get_headers();
    this.get_forms();
    const saved_tab = localStorage.getItem("active_tab");
    if (saved_tab && this.tabs.includes(saved_tab)) {
      this.active_tab = saved_tab;
      if (saved_tab === "Template") {
        this.get_assigned_templates();
        this.view_signing_workflow();
      }
    }
    this.initialize_data_table();

    if (this.$route.query.auto_assign === 'true' && this.$route.query.entity_type_id) {
      this.show_success("Template uploaded and assigned successfully");
      this.get_assigned_templates();
      this.view_signing_workflow();
      this.$router.replace({ query: null });
    }
  },
  methods: {
    async select_template(template, action="") {
      this.selected_template = { ...template };
      const unsanitized = this.manage_template.find(
        (t) => t.id === template.id
      );
      if (unsanitized) {
        this.selected_template.document_url = unsanitized.document_url;
        this.selected_template.presigned_url = unsanitized.presigned_url;
      }
      if (action === "view") {
        this.preview_modal = true;
      }
    },

    async handle_file_selection(evt) {
      const file = evt.target.files[0];

      if (!file) {
        this.selected_file = null;
        return;
      }

      try {
        const validation = await validate_file(file);

        if (!validation.valid) {
          this.show_error(validation.error);
          evt.target.value = "";
          this.selected_file = null;
          return;
        }

        this.selected_file = file;
      } catch (error) {
        this.show_error("Error validating file");
        evt.target.value = "";
        this.selected_file = null;
      }
    },

    validate_template_name_input() {
      if (!this.new_template_name) {
        this.show_error("Template name is required.");
        return false;
      }

      if (!validate_non_empty_string(this.new_template_name)) {
        this.show_error("Template name must not be empty");
        return false;
      }

      return true;
    },

    async upload_and_assign_template() {
      if (!this.validate_template_name_input()) return;
      if (!this.selected_file) {
        this.show_error("Please select a file to upload");
        return;
      }

      this.upload_loading = true;

      const formData = new FormData();
      formData.append("name", this.new_template_name);
      formData.append("project_id", this.project_id);
      formData.append("document_file", this.selected_file);

      try {
        const uploadResponse = await axios.post(UPLOAD_TEMPLATE_URL, formData, {
          headers: {
            ...this.headers,
            "Content-Type": "multipart/form-data",
          },
        });

        if (uploadResponse.data.status === "success") {
          const templateId = uploadResponse.data.data.id;

          const assignPayload = {
            template_id: templateId,
            entity_type_id: this.entity_type_id,
            is_assigned: true,
          };

          const assignResponse = await axios.post(ASSIGN_UPDATE_TEMPLATE, assignPayload, {
            headers: this.headers,
          });

          if (assignResponse.data.status === "success") {
            this.show_success("Template uploaded and assigned successfully");
            this.get_assigned_templates();
            this.close_upload_modal();
          } else {
            this.show_error("Template uploaded but assignment failed");
          }
        } else {
          this.show_error(uploadResponse.data.message || "Template upload failed");
        }
      } catch (error) {
        let errorMsg = "Error during template upload and assignment";
        if (error.response) {
          if (error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message;
          } else if (error.response.data && typeof error.response.data === "string") {
            try {
              const parsed = JSON.parse(error.response.data);
              errorMsg = parsed.message || errorMsg;
            } catch (e) {
              errorMsg = error.response.data || errorMsg;
            }
          }
        }
        this.show_error(errorMsg);
      } finally {
        this.upload_loading = false;
      }
    },

    open_upload_modal() {
      this.show_upload_modal = true;
      this.new_template_name = "";
      this.selected_file = null;
      const fileInput = document.querySelector("#template-upload-input");
      if (fileInput) fileInput.value = "";
    },

    close_upload_modal() {
      this.show_upload_modal = false;
    },

    async update_template() {
      if (!this.validate_template_name_input()) return;

      this.loading = true;

      const form_data = new FormData();
      form_data.append("template_id", this.selected_template.id);

      if (this.selected_file) {
        form_data.append("new_document_file", this.selected_file);
      }

      form_data.append("new_name", this.selected_template.template_name);
      form_data.append("new_project_id", this.project_id);

      try {
        const config = {
          headers: {
            ...this.headers,
            "Content-Type": "multipart/form-data",
          },
        };

        const response = await axios.post(UPDATE_TEMPLATE, form_data, config);

        if (response.data.status === "success") {
          this.show_success("Template updated successfully.");

          if (response.data.data) {
            this.selected_template.version = response.data.data.version;
            if (response.data.data.document_url) {
              this.selected_template.document_url =
                response.data.data.document_url;
            }
            if (response.data.data.name) {
              this.selected_template.name = response.data.data.name;
            }
          }

          await this.get_assigned_templates();
        } else {
          this.show_error(response.data.message || "Failed to update template");
        }
      } catch (error) {
        let error_msg = "Update failed";

        if (error.response) {
          if (error.response.data.data) {
            error_msg = Object.values(error.response.data.data).join(", ");
          } else {
            error_msg = error.response.data.message || error_msg;
          }
        } else {
          error_msg = error.message || error_msg;
        }

        this.show_error(error_msg);
      } finally {
        this.loading = false;
      }
    },

    configure_template(template_id) {
      const template = this.manage_template.find((t) => t.id === template_id);
      if (!template) return;

      this.$router.push({
        path: "/configure_template",
        query: {
          template_id: template_id,
        },
      });
    },

    async view_signing_workflow() {
      const params = { project_id: this.project_id };

      try {
        const response = await axios.post(LIST_WORFLOWS, {}, {
          headers: this.headers,
          params: params,
        });
        const response_data = response.data;
        this.workflows = response_data.workflows.map((workflow) => ({
          id: workflow.id,
          name: workflow.name,
          description: workflow.description || '',
        }));
        this.workflows_table_headers = this.workflows.length > 0 ? Object.keys(this.workflows[0]) : [];
      } catch (error) {
        const error_message = error.response?.data?.message || error.response?.data?.detail || error.message;
        this.show_error(`Error fetching workflows: ${error_message}`);
      }
    },

    select_entity_type_template(template_document_entity_type_id) {
      this.assigned_workflow = [];
      this.template_document_entity_type_id = template_document_entity_type_id;

      const payload = {
        template_document_entity_type_id: this.template_document_entity_type_id,
      };

      axios
        .post(GET_WORKFLOW_ASSIGNED_TO_TEMPLATE, payload, { headers: this.headers })
        .then(response => {
          if (response.data?.data && Array.isArray(response.data.data)) {
            this.assigned_workflow = response.data.data.map(item => item.workflow);
          }
        })
        .catch(() => {
          this.show_error("Error fetching assigned workflow:");
        });
    },



    toggle_assignment(workflow_id) {
      const payload = {
        template_document_entity_type_id: this.template_document_entity_type_id,
        workflow_id: workflow_id
      };

      if (this.assigned_workflow.includes(workflow_id)) {
        payload.is_assigned = false;
      } else {
        payload.is_assigned = true;
      }

      axios.post(ASSIGN_WORKFLOW_TO_ENTITY_TYPE_TEMPLATE, payload, { headers: this.headers })
        .then(() => {
          if (payload.is_assigned) {
            this.assigned_workflow = [];
            this.assigned_workflow.push(workflow_id);
          } else {
            this.assigned_workflow = this.assigned_workflow.filter(id => id !== workflow_id);
          }
        })
        .catch(() => {
          this.show_error("Error fetching users");
        });
    },


    async set_active_tab(tab) {
      this.active_tab = tab;
      localStorage.setItem("active_tab", tab);
      await nextTick();

      if (tab === "Template") {
        await this.get_assigned_templates();
      } else if (tab === "Forms") {
        this.get_forms();
      }
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const table_ids = {
          "Forms": "#manage-forms-table",
          "Template": "#manage-template-table",
          "Invoice Steps": "#manage-invoice-table",
          "Compliance": "#manage-compliance-table",
        };

        const tableId = table_ids[this.active_tab];

        const tableElement = document.querySelector(tableId);
        if (!tableElement) {
          return;
        }

        if ($.fn.DataTable.isDataTable(tableId)) {
          $(tableId).DataTable().destroy();
        }
        $(tableId).DataTable();
      });
    },

    redirect_to_create_entity(form_id) {
      sessionStorage.setItem("form_id", form_id);
      this.$router.push({
        path: "/create_entity",
        query: { form_id: form_id , entity_type_name: this.entity_type_name },
      });
    },

    redirect_to_upload_template() {
      this.$router.push({
        path: "/upload_template",
        query: {
          auto_assign: true,
          entity_type_id: this.entity_type_id,
          return_path: this.$route.path
        }
      });
    },

    set_document_url(template) {
      this.document_url = template.document_url || null;
    },

    edit_template() {
      this.show_success("Template edited successfully.");
    },

    get_forms() {
      this.form_list = [];

      var query_params = {
        entity_type_id: this.entity_type_id,
      };

      axios
        .get(GET_ENTITY_TYPE_FORMS, {
          headers: this.headers,
          params: query_params,
        })
        .then((response) => {
          const parsed_response = JSON.parse(response.data);

          if (parsed_response.data && parsed_response.data.length > 0) {
            this.form_list = parsed_response.data;
            this.prep_tables();
          }
        })
        .catch((error) => {
          this.show_error("Error getting forms: " + error);
          return;
        });
    },

    prep_tables() {
      if (this.form_list.length > 0) {
        const table_safe_form_list = this.form_list.map((form) => ({
          form_id: form.id,
          Form: form.form_name,
          Description: form.form_description,
          Status: form.status,
          "Date Created": this.format_date(form.date_created),  // <-- using mixin method
        }));
        this.form_table_headers = Object.keys(table_safe_form_list[0]);
        this.table_safe_form_list = table_safe_form_list;
      }
    },

    create_form() {
      if (!validate_non_empty_string(this.form_name)) {
        this.show_error("Form name is required.");
        return;
      }

      if (this.form_description !== "") {
        if (!validate_non_empty_string(this.form_description)) {
          this.show_error("Form description");
          return;
        }
      }

      var payload = {
        project_id: this.project_id,
        form_name: this.form_name,
        form_description: this.form_description || null,
      };

      axios
        .post(CREATE_FORM, payload, { headers: this.headers })
        .then(() => {
          this.show_success(
            `Form ${this.form_name} created successfully.`
          );
          sessionStorage.setItem("form_name", this.form_name);
          this.close_modal("create_form");
          this.get_forms();
        })
        .catch(() => {
          this.show_error(
            "Error creating entity form: " + "Form already exists"
          );
          this.close_modal("create_form");
        });
    },

    async share_trust_setup() {
      if (!validate_non_sub_zero_number(parseInt(this.selected_form_id, 10))) {
        this.show_error("Please select a form to share");
        return;
      }

      if (!this.email || !this.email.includes("@")) {
        this.show_error("Please enter a valid email address");
        return;
      }

      try {
        const data = {
          form_id: parseInt(this.selected_form_id, 10),
          email: this.email,
        };

        const response = await axios.post(ENTITY_REGISTER, data, {
          headers: this.headers,
        });

        if (response.data) {
          this.show_success("Trust form successfully shared.");
          this.close_modal("share_trust_form");
          this.email = "";
        }
      } catch (error) {
        this.show_error(
          error.response?.data?.message ||
          "Cannot share form, user with email already exists"
        );
        this.close_modal("share_trust_form");
      }
    },

    selected_share_form_id(form_id) {
      this.selected_form_id = form_id;
    },

    async get_assigned_templates() {
  this.loading_templates = true;
  try {
    const response = await axios.get(LIST_STATUS_TEMPLATE, {
      headers: this.headers,
      params: {
        project_id: this.project_id,
        entity_type_id: this.entity_type_id,
      },
    });

    if (!response.data.data) {
      throw new Error("No data in response");
    }

    let templatesData = [];
    if (Array.isArray(response.data.data)) {
      templatesData = response.data.data;
    } else if (response.data.data.active_assignments) {
      templatesData = Array.isArray(response.data.data.active_assignments)
        ? response.data.data.active_assignments
        : [];
    }

        this.manage_template = templatesData.map((assignment) => {
          const uploaded_raw = assignment.created_at || new Date().toISOString();
          const modified_raw = assignment.updated_at || uploaded_raw;

          return {
            id: assignment.id,
            template_name: assignment.template_name || "Unnamed Template",
            file_type: assignment.document_url ? assignment.document_url.slice(assignment.document_url.lastIndexOf(".") + 1) : "Unknown File Type",
            date_uploaded: new Date(uploaded_raw).toLocaleString(),
            date_modified: new Date(modified_raw).toLocaleString(),
            document_url: assignment.document_url || null,
            presigned_url: assignment.presigned_url || null,
            version: assignment.version || 1,
            entity_type_name: assignment.entity_type_name,
            template_document_id: assignment.template_document
          };
        });
      } catch (error) {
        this.show_error(
          "Error fetching templates: " +
          (error.response?.data?.message || error.message)
        );
        this.manage_template = [];
      } finally {
        this.loading_templates = false;
      }
    },

    close_the_file_preview() {
      this.preview_modal = false;
    },

    redirect_to_manage_entity_type() {
      this.$router.push({
        path: "/manage_entity_type",
      });
    },
  },
};